import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type { PaymentRequest } from "./paymentRequest"

export type RetrievePaymentRequestResponse = PaymentRequest

const retrievePaymentRequest = async (
  paymentRequestId?: PaymentRequest["ident"]
): Promise<RetrievePaymentRequestResponse> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<RetrievePaymentRequestResponse>
  >(`/beepaidgo/payment-requests/${paymentRequestId}/`)

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
    lastSentAt: body.lastSentAt
      ? DateFns.parseISO(body.lastSentAt)
      : null,
  }
}

export const usePaymentRequest = (
  paymentRequestId?: MaybeRef<PaymentRequest["ident"]>
) =>
  useQuery({
    queryKey: [
      PAYMENT_REQUESTS_QUERY_KEY,
      paymentRequestId,
    ] as const,
    queryFn: ({ queryKey: [_, paymentRequestId_] }) =>
      retrievePaymentRequest(paymentRequestId_),
  })
